import { EQueryParameters as EPeriod } from '../../../repositories/valuation-offer-history/v1/get-market-trand';
import { today } from '../../../utils/getTodayDate';
import { sub } from 'date-fns';

export function useGetMinDate(period: EPeriod) {
  switch (period) {
    case EPeriod.OneYear:
      return +sub(today(), { years: 1 });
    case EPeriod.SixMonths:
      return +sub(today(), { months: 6 });
    default:
      return +sub(today(), { years: 5 });
  }
}
